<template>
  <div>
    <!-- Form -->
    <v-container grid-list-md>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }}</span>
          </v-card-title>
          <v-form
            method="post"
            :action="base_path"
            target="_blank"
            id="report_generator"
            v-model="valid"
            ref="form"
            lazy-validation
          >

            <!-- action="http://202.161.191.130:8080/backend/backend/phpjasperxml/" -->
            <!-- action="http://localhost/IPFF2/backend/phpjasperxml/" -->

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-autocomplete
                      label="Module Name"
                      item-text="menu_name"
                      item-value="id"
                      v-model="formSchema.menu_id"
                      :items="MainMenus"
                      @change="getReportMaster"
                    ></v-autocomplete>
                    <p style="color:red" id="menu_id"></p>
                  </v-flex>

                  <v-flex xs12 sm8 md8 class="pr-4">
                    <v-autocomplete
                      label="Report Master"
                      item-text="report_title"
                      item-value="id"
                      v-model="formSchema.report_id"
                      :items="ReportName"
                      @change="getReportParameters"                      
                    ></v-autocomplete>
                    <p style="color:red" id="report_id"></p>
                  </v-flex>
                  <!-- Appended Fields -->
                  <v-flex
                    xs12
                    sm6
                    md4
                    class="pr-4"
                    v-for="(report,index) in reportFields"
                    :key="index"
                    >        
                    <v-text-field
                      v-if="report.type == 'TEXT'"
                      :label="report.title"
                      v-model="onlyParam[report.name]"
                      @input="setSelectValue()"
                    ></v-text-field>

                    <v-text-field
                      v-if="report.type == 'INT'"
                      type="number"
                      :label="report.title"
                      v-model="onlyParam[report.name]"
                      @input="setSelectValue()"
                    ></v-text-field>

                    <v-autocomplete
                      v-if="report.type == 'LIST'"
                      @input="setSelectValue()"
                      :label="report.title"
                      :item-text="report.col_title"
                      :item-value="report.col_id"
                      clearable
                      single-line hide-details 
                      v-model="onlyParam[report.name]"
                      :items="report.selectData"
                    ></v-autocomplete>
     
                    <DatePicker
                      v-if="report.type == 'DATE'"
                      :key="index+1"
                      :inputData="{index:1,fieldName:report.name, fieldValue:onlyParam[report.name], type:report.type, label:report.title, required:report.required}"
                      @setValue="setDateValue"
                    ></DatePicker>                    
                    <p style="color:red" :id="report.name"></p>
                  </v-flex>

                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-container fluid style="padding:0px">
                      <v-radio-group v-model="formSchema.report_type" row>
                        <v-radio label="PDF" name="report_type" :value="1"></v-radio>
                        <v-radio label="Excel" name="report_type" :value="2"></v-radio>
                        <v-radio label="Word" name="report_type" :value="3"></v-radio>
                      </v-radio-group>
                      <p style="color:red" id="report_id"></p>
                    </v-container>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="info" flat @click.native="validateBeforeSubmit">
                <v-icon>refresh</v-icon>Reset
              </v-btn>
              <v-btn
                class="success"
                @click="checkForm"
                flat
                v-if="userRole.saveButton || userRole.updateButton"
              >
                <v-icon>get_app</v-icon>Generate Report
              </v-btn>
            </v-card-actions>

            <input type="hidden" name="file_name" v-model="formSchema.file_name" />
            <input type="hidden" name="pro_id" v-model="formSchema.pro_id" />
            <div v-for="(hField,index1) in selectValues" :key="index1">
              <input type="hidden" :name="hField.name" :value="hField.value" />
            </div>
          </v-form>
        </v-card>
      </v-flex>
    </v-container>
    <!-- /Form -->    

  </div>
</template>

<script>
let commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";
import ServerPath from '../../../server-path/server-path';

export default {
components: { 
      DatePicker, 
    },
  data: vm => ({
    valid: true,
    ParameterData: "",
    html: "",
    MainMenus: [],
    ReportName: [],
    reportDetails: [],
    reportFields: [],

    tableData: [],
    selectValues: [],
    base_path: window.location,
    formSchema: {
      id: "",
      report_id: "",
      menu_id: "",
      file_name: "",
      pro_id: "",
      report_type: 1
    },
    onlyParam: {},

    paramVal:'',
    componentName:'',
  }),

  computed: {
    formTitle() {
      return "Report Making";
    },

    // User Previlization methods
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  created() {
    let root = this;
    // Asset Location List
    commonService.getAllData("get_menu_info").then(res => {
      root.MainMenus = res.data;
    });
  },

  methods: {
    // Set Parameter Input Value
    setSelectValue() {
      this.selectValues = [];
      let paramData = [];
      let array = this.onlyParam;
      for (const prop in array) {
        //var name = ${prop};
        paramData.push({
          name: `${prop}`,
          value: "'" + `${array[prop]}` + "'"
        });
      }
      var param_data = JSON.stringify(paramData);
      this.selectValues.push({ name: "parameter_data", value: param_data });
    },
    // On submit Validation

    checkForm() {      


      let reportFields = this.reportFields;
      let pass = true;
      var formSchema = this.formSchema;

      let onlyParam = this.onlyParam;
      onlyParam.project_id = this.formSchema.pro_id
      onlyParam.report_type = this.formSchema.report_type
      onlyParam.funcName = this.formSchema.file_name
      onlyParam.conName = this.formSchema.controllerShortName

      //console.log('onlyParam', onlyParam);

      document.getElementById("menu_id").innerHTML = "";
      document.getElementById("report_id").innerHTML = "";
      if (formSchema.menu_id == "") {
        document.getElementById("menu_id").innerHTML = "Field is required !!";
        document.getElementById("report_id").innerHTML = "Field is required !!";
      } else if (formSchema.report_id == "") {
        document.getElementById("report_id").innerHTML = "Field is required !!";
      } else {
        reportFields.forEach(function(input) {
          document.getElementById(input.name).innerHTML = "";
          if (input.required == 1 && onlyParam[input.name] == "") {
            document.getElementById(input.name).innerHTML =
              "Field is required !!";
            pass = false;
          }
        });
        if (pass == true) {
          // Form submission
          
          /*if(this.formSchema.file_name == '')
          {
            document.getElementById("report_generator").submit();
            return 0;
          }*/


          if(this.formSchema.file_name != '' && this.formSchema.file_name != 'null' )
          {            
            /*if(this.formSchema.report_type == 1)
            {*/

              let parameters = new URLSearchParams({ ...onlyParam}).toString();
                          
              /*console.log('onlyParam', onlyParam);
              console.log('parameters', parameters);
              return 0;*/

              sessionStorage.setItem('report', JSON.stringify(onlyParam))
              let route = ServerPath.serverPath+'/pdf?'+parameters;
              window.open(route, '_blank');
            /*}
            else
            {
              localStorage.removeItem('report');
              this.componentName = this.formSchema.funcName;              
              setTimeout(function(){ 
                root.componentName = ''
              },3000); 
            }*/
          }

        }
      }
    },


    // Table Data get
    getSelectList(table) {
      let tableData = {};
      commonService.getAllDataByTable(table, "get_table_data").then(res => {
        return res.data;
      });
    },

    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;
      var root = this;
      if (root.$refs.form.validate()) {
        commonService
          .insertFormData(this.formSchema, "report_generated_file")
          .then(res => {
            let actionData = {
              message: res.message,
              status: res.status
            };
            this.close(actionData);
          });
      }
    },

    // Asset Location List
    getReportMaster() {
      this.selectValues = [];
      var menu_id = this.formSchema.menu_id;
      commonService
        .getAllDataById(menu_id, "get_report_master_by_module")
        .then(res => {
          this.ReportName = res.data;
          this.formSchema.pro_id = res.p_id;
          this.base_path = res.base_path;
        });
    },

    getReportParameters() {
      this.reportFields = [];
      var storeField = []

      this.onlyParam['P_FROM_DATE'] = '';
      var root = this;
      var report_id = this.formSchema.report_id;
      root.onlyParam = {};
      this.selectValues = [];
      // get file name
      var index = this.ReportName.map(function(e) {
        return e.id;
      }).indexOf(report_id);
     // console.log('this.ReportName[index]',this.ReportName[index]);
      var file_name = this.ReportName[index].file_name;
      this.formSchema.file_name = file_name;
      this.formSchema.controllerShortName = this.ReportName[index].con_short_name;
      var tableData = {};
      commonService
        .getAllDataById(report_id, "get_report_parameters")
        .then(res => {
          root.onlyParam = [];

          var reportDetails = [];
                              
          res.data.forEach(function(repo) {
            if (repo.report_parameter.parameter_type == "LIST") {

              // console.log("--------------test--------------");
              // tableData = root.getSelectList(repo.report_parameter.table_name);
              // console.log("tableData = ", tableData);
              
              //repo.report_parameter.table_name+'/'+repo.report_parameter.id,
              commonService
                .getAllDataByTable(repo.report_parameter.id,
                  "get_table_data"
                )
                .then(res => {

                  root.$set(storeField, (Number(repo.serial_num)+0)-1, { ...{
                    serial: repo.serial_num,
                    title: repo.parameter_title,
                    name: repo.report_parameter.parameter_name,
                    type: repo.report_parameter.parameter_type,
                    required: repo.is_mandatory,
                    selectData: res.data,
                    col_title: repo.report_parameter.column_ref_1,
                    col_id: repo.report_parameter.column_ref_2
                  } });

                  /*storeField.push({
                    serial: repo.serial_num,
                    title: repo.parameter_title,
                    name: repo.report_parameter.parameter_name,
                    type: repo.report_parameter.parameter_type,
                    required: repo.is_mandatory,
                    selectData: res.data,
                    col_title: repo.report_parameter.column_ref_1,
                    col_id: repo.report_parameter.column_ref_2
                  });*/
                });
                
            } else {

              root.$set(storeField, (Number(repo.serial_num)+0)-1, { ...{
                serial: repo.serial_num,
                title: repo.parameter_title,
                name: repo.report_parameter.parameter_name,
                type: repo.report_parameter.parameter_type,
                required: repo.is_mandatory,
                selectData: tableData,
                col_title: repo.report_parameter.column_ref_1,
                col_id: repo.report_parameter.column_ref_2
              } });

              /*storeField.push({
                serial: repo.serial_num,
                title: repo.parameter_title,
                name: repo.report_parameter.parameter_name,
                type: repo.report_parameter.parameter_type,
                required: repo.is_mandatory,
                selectData: tableData,
                col_title: repo.report_parameter.column_ref_1,
                col_id: repo.report_parameter.column_ref_2
              });*/
            }

            root.reportFields = storeField
            var f_key = repo.report_parameter.parameter_name;
            root.onlyParam[f_key] = "";
          });

          
          //this.ParameterData = JSON.stringify(root.formSchema);
        });
    },
    // Set Date Input Here
    setDateValue(data) {
      //set Date to field
      let index = data.index;
      this.onlyParam[data.fieldName] = this.changeFormateYMD(data.value);
      // Get Value
      this.selectValues = [];
      let paramData = [];
      let array = this.onlyParam;
      for (const prop in array) {
        //var name = ${prop};
        paramData.push({
          name: `${prop}`,
          value: "'" + `${array[prop]}` + "'"
        });
      }
      //value: "'" + `${array[prop]}` + "'"
      var param_data = JSON.stringify(paramData);
      this.selectValues.push({ name: "parameter_data", value: param_data });
    },
    // Date picker Method Function
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    // Date picker Method Function End
    close: function(message) {
      this.$refs.form.reset();
      this.reportFields = [];
      this.selectValues = [];
    }
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/report/report_interface/report_interface.vue